/**
 * CTA block parallax effect
 * Slides the background logo from off-screen left towards the center of the block
 * as the user scrolls. Mirror effect of the presentation block.
 */
const ctaBlockParallax = () => {
  const block = document.querySelector(".cta-block");
  if (!block) return;

  const logo = block.querySelector(".cta-block-bg-logo");
  if (!logo) return;

  let ticking = false;

  const update = () => {
    const rect = block.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // progress: 0 when block enters viewport from below, 1 when fully visible
    const progress = Math.min(Math.max((viewportHeight - rect.top) / (viewportHeight + rect.height), 0), 1);

    // Slide from left: starts at left:-60% (CSS), moves right by up to 50% of block width
    const blockWidth = block.offsetWidth;
    const translateX = Math.min(progress * blockWidth * 0.7, blockWidth * 0.4);
    const rotate = 5 - progress * 10;

    logo.style.transform = `translateY(-50%) translateX(${translateX}px) rotate(${rotate}deg)`;
    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load in case block is already in view
  requestAnimationFrame(update);
};

ctaBlockParallax();

export default ctaBlockParallax;
